import React from 'react';
import moment from "moment";

const columns = (actions = {}, t = (s) => s) => {
  const defaultColumns = [
    {
      title: t('Title'),
      dataIndex: 'title',
      key: 'title',
      sorter: (a, b) => ('' + a.title).localeCompare(b.title),
      render: (title, all) => (
        <label
          style={{ color: 'var(--mmt-primary-70)', cursor: 'pointer', fontWeight: 500, marginBottom: 0 }}
          onClick={() => {
            if (typeof actions.setActiveMitigation === 'function') {
              actions.setActiveMitigation(all);
            }
          }}
        >
          {title}
        </label>
      )
    },
    {
      title: t('Created'),
      dataIndex: 'createdAt',
      key: 'createdAt',
      sorter: (a, b) => moment(a.createdAt).diff(moment(b.createdAt)),
      render: (date) => moment(date).format('DD MMMM YYYY'),
    },
    {
      title: t('Actions Associated'),
      dataIndex: 'events',
      key: 'actionsAssociated',
      sorter: (a, b) => (a.events || []).length - (b.events || []).length,
      render: (actions = []) => actions.length ? (
        <label
          style={{ fontWeight: 500, marginBottom: 0 }}
        >
          {`${actions.length} ${t('associated actions')}`}
        </label>
      ) : t('No associated actions'),
    },
    {
      title: t('Last Updated'),
      dataIndex: 'createdAt',
      key: 'createdAt',
      sorter: (a, b) => moment(a.createdAt).diff(moment(b.createdAt)),
      render: (date) => moment(date).format('DD MMMM YYYY'),
    },
  ];

  return {
    proposed: defaultColumns,
    inProgress: defaultColumns,
    completed: [
      defaultColumns[0],
      defaultColumns[1],
      defaultColumns[2],
      {
        title: t('Completed'),
        dataIndex: 'completedAt',
        key: 'completedAt',
        sorter: (a, b) => moment(a.completedAt).diff(moment(b.completedAt)),
        render: (date) => moment(date).format('DD MMMM YYYY'),
      },
    ],
  };
};

export default columns;
